import { combineReducers } from '@reduxjs/toolkit';
import { authStates } from '../authStates';
import userReducer from './user';
import socketClientReducer from './socket';
import uiReducer from './ui';
import userOrganizationReducer from './userOrganization';
import { prospectSearchReducer } from '../ducks/prospect-search-filters';
import prospectSearchResultSlice from '../ducks/prospect-search-result/slice';
import importProspectsReducer from './import-prospects/importProspects';

const appReducer = combineReducers({
    // campaigns: campaignReducer,
    importProspects: importProspectsReducer,
    // prospects: prospectsSlice,
    prospectSearchFilters: prospectSearchReducer,
    prospectSearchResult: prospectSearchResultSlice,
    socketClient: socketClientReducer,
    // salesforce: salesforceReducer,
    ui: uiReducer,
    user: userReducer,
    userOrganization: userOrganizationReducer,
});

const rootReducer = (state, action) => {
    if (action.type === 'RESET_STORE') {
        state = {
            user: {
                zaplifyUser: {},
                firebaseUser: {},
                currentState: authStates.LOGGED_OUT,
                authErrorMessage: null,
            },
        };
    }

    return appReducer(state, action);
};

export default rootReducer;
